import { CLIENT } from "callable-data-objects";
import { get as getWidget } from "Components/Device/Flow/constants";
import EndpointForm from "Components/Device/Forms/EndpointForm";
import General from "Components/Device/Forms/General";
import DeleteForm from "Components/Shared/DeleteForm";
import React, { useState } from "react";
import { Grid, Icon, Menu } from "semantic-ui-react";
import ConnectTo from "../Forms/ConnectTo";
import ClientAdvanced from "./ClientAdvanced";
import ClientCredentials from "./ClientCredentials";
import ClientQueues from "./ClientQueues";
import ClientUser from "./ClientUser";

const ClientView = () => {
  const [activeMenu, setActiveMenu] = useState<string>("general");
  const widget = getWidget(CLIENT);

  const isHandler = () => {
    return (
      ["onComplete", "onBusy", "onFail", "onNoAnswer"].find(
        (s) => activeMenu === s
      ) !== undefined
    );
  };

  return (
    <Grid stackable columns={2}>
      <Grid.Column width={3}>
        <Menu size='mini' vertical fluid pointing>
          <Menu.Item header>
            <Icon name={widget.icon} color={widget.color} />
            {widget.name}
          </Menu.Item>
          <Menu.Item
            name='general'
            active={activeMenu === "general"}
            onClick={() => setActiveMenu("general")}
          >
            General Configuration
          </Menu.Item>
          <Menu.Item
            name='endpoint'
            active={activeMenu === "endpoint"}
            onClick={() => setActiveMenu("endpoint")}
          >
            Call Configuration
          </Menu.Item>
          <Menu.Item
            name='credentials'
            active={activeMenu === "credentials"}
            onClick={() => setActiveMenu("credentials")}
          >
            Credentials
          </Menu.Item>
          <Menu.Item
            name='user'
            active={activeMenu === "user"}
            onClick={() => setActiveMenu("user")}
          >
            User
          </Menu.Item>
          <Menu.Item
            name='contacts'
            active={activeMenu === "contacts"}
            onClick={() => setActiveMenu("contacts")}
          >
            Contacts
          </Menu.Item>
          <Menu.Item
            name='queues'
            active={activeMenu === "queues"}
            onClick={() => setActiveMenu("queues")}
          >
            Queues
          </Menu.Item>
          <Menu.Item
            name='advanced'
            active={activeMenu === "advanced"}
            onClick={() => setActiveMenu("advanced")}
          >
            Advanced
          </Menu.Item>

          <Menu.Item
            name='onComplete'
            active={activeMenu === "onComplete"}
            onClick={() => setActiveMenu("onComplete")}
          >
            On Complete
          </Menu.Item>
          <Menu.Item
            name='onNoAnswer'
            active={activeMenu === "onNoAnswer"}
            onClick={() => setActiveMenu("onNoAnswer")}
          >
            On No Answer
          </Menu.Item>
          <Menu.Item
            name='onBusy'
            active={activeMenu === "onBusy"}
            onClick={() => setActiveMenu("onBusy")}
          >
            On Busy
          </Menu.Item>
          <Menu.Item
            name='onFail'
            active={activeMenu === "onFail"}
            onClick={() => setActiveMenu("onFail")}
          >
            On Fail
          </Menu.Item>

          <Menu.Item
            name='delete'
            active={activeMenu === "delete"}
            onClick={() => setActiveMenu("delete")}
          >
            <b style={{ color: "red" }}>Delete</b>
          </Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column width={13}>
        {activeMenu === "credentials" && <ClientCredentials />}
        {activeMenu === "user" && <ClientUser />}
        {activeMenu === "queues" && <ClientQueues />}
        {activeMenu === "advanced" && <ClientAdvanced />}
        {activeMenu === "general" && <General />}
        {activeMenu === "delete" && <DeleteForm />}
        {activeMenu === "endpoint" && <EndpointForm fieldName='client' />}
        {isHandler() && <ConnectTo type='client' field={activeMenu} />}
      </Grid.Column>
    </Grid>
  );
};

export default ClientView;
